import { map } from "rxjs";
import { _IDataSourceControlBase } from "../types/i-data-source-control.base";

const mapItemDisplay = () =>
  map(([item, displayExpr]: [any, _IDataSourceControlBase['displayExpr']]) => {

    if (!item) {
      return '';
    }

    if (!displayExpr) {
      return item.text;
    }

    if (typeof displayExpr === 'function') {
      return displayExpr(item);
    }

    return item[displayExpr]
  })

export default mapItemDisplay;
